import { Avatar } from 'module/ui/components/atoms/avatar';
import { HeadingCompact01, Short00 } from 'module/ui/components/styles';
import {
  AccountPeopleProfile,
  UserEducation,
} from 'api/account-people/profile-type';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Collapsible, EmptyContent } from './collapsible-section';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
`;

const ExperienceItem = styled.div`
  display: flex;
  gap: var(--spacing-03);
`;
const Role = styled.div`
  ${HeadingCompact01};
`;
const Company = styled.div`
  ${Short00};
`;
const Timeline = styled.div`
  ${Short00};
  color: var(--text-tertiary);
`;
const ExperienceItemContent = styled.div`
  display: flex;
  flex-direction: column;
  ${Company} {
    margin-top: var(--spacing-01);
  }
  ${Timeline} {
    margin-top: var(--spacing-02);
  }
`;
const getStartAndEnd = (education: UserEducation) => {
  const isPresent = education.endDate == null;
  const start = moment(education.startDate).format('YYYY');
  const end = isPresent
    ? moment().format('YYYY')
    : moment(education.endDate).format('YYYY');

  if (start === end) {
    return {
      start: moment(education.startDate).format('MMM YYYY'),
      end: isPresent ? null : moment(education.endDate).format('MMM YYYY'),
    };
  }

  return {
    start,
    end: isPresent ? null : end,
  };
};

interface Props {
  userProfile: AccountPeopleProfile;
}
export const Education: React.FC<Props> = ({ userProfile }) => {
  const isEmpty =
    (userProfile.userProfile?.enrichedUserData?.userEducation?.length ?? 0) ===
    0;

  return (
    <Collapsible
      title={
        <FormattedMessage id="account.people.profile.sections.education.title" />
      }
      panelKey="education"
    >
      {isEmpty ? (
        <EmptyContent>
          <FormattedMessage id="account.people.profile.sections.education.empty" />
        </EmptyContent>
      ) : (
        <Wrapper>
          {userProfile.userProfile?.enrichedUserData?.userEducation?.map(
            (education) => {
              const { start, end } = getStartAndEnd(education);

              return (
                <ExperienceItem key={education.institution}>
                  <Avatar
                    src={education.institutionUrl}
                    name={education.institution}
                    size={32}
                    shape="square"
                  />
                  <ExperienceItemContent>
                    <Role>{education.institution}</Role>
                    <Company>{education.fieldOfStudy}</Company>
                    <Timeline>
                      {start} -{' '}
                      {end ? (
                        end
                      ) : (
                        <FormattedMessage id="account.people.profile.sections.experience.present" />
                      )}
                    </Timeline>
                  </ExperienceItemContent>
                </ExperienceItem>
              );
            },
          )}
        </Wrapper>
      )}
    </Collapsible>
  );
};
